import { render, staticRenderFns } from "./ctgz.vue?vue&type=template&id=74c671c5&scoped=true&"
import script from "./ctgz.vue?vue&type=script&lang=js&"
export * from "./ctgz.vue?vue&type=script&lang=js&"
import style0 from "./ctgz.vue?vue&type=style&index=0&id=74c671c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c671c5",
  null
  
)

export default component.exports